import { render, staticRenderFns } from "./DetailsKeepingSector.vue?vue&type=template&id=b0553cd8&scoped=true"
import script from "./DetailsKeepingSector.vue?vue&type=script&lang=js"
export * from "./DetailsKeepingSector.vue?vue&type=script&lang=js"
import style0 from "./DetailsKeepingSector.vue?vue&type=style&index=0&id=b0553cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0553cd8",
  null
  
)

export default component.exports